<template>
<div class="d-flex h-100 w-100 justify-content-center project-management-container">
  <div class="card project-management-panel w-100" style="overflow: auto">

    <div class="nav-outer-wrapper">
      <b-navbar toggleable="md" type="dark" class="primaryNav">
        <b-navbar-brand><img src="../../assets/kegs-logo-sml.png" v-b-tooltip.hover title="KEGS Field Developer"></b-navbar-brand>
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <!--START FIRST NAV SECTION (MAIN TOOLSET) -->
          <b-collapse is-nav id="nav_collapse">
            <span id="project-management-title">Project Managment</span>
          </b-collapse>
          <b-navbar-nav class="my-0 right-nav-btns">
            <b-nav-item>
              <b-button v-b-tooltip.hover.bottom title="User Menu" @click="toggleRightMenu" class="showRight nav-link user-menu-button bg-inverse">
                <span class="menu-icon">
                    <icon name="bars"></icon>
                  </span></b-button>
            </b-nav-item>
          </b-navbar-nav>
      </b-navbar>
    </div>
    <div id="project-management-inner-container">
      <div class="inner-admin-container">
        <b-tabs v-model="tabIndex" pills card>
          <b-tab no-body title="Workpack" active>
            <br><WorkpackSettings :tabIndex="tabIndex"></WorkpackSettings>
          </b-tab>
          <b-tab no-body title="Settings">
            <br><GeneralConfig></GeneralConfig>
          </b-tab>
          <b-tab no-body title="Layers">
            <br><LayerSettings></LayerSettings>
          </b-tab>
          <b-tab no-body title="Layer Groups">
            <br><LayerGroupSettings></LayerGroupSettings>
          </b-tab>
          <b-tab title="Data" v-if="isToolEnabled('admin_board_data_upload')">
            <br><StandardDataUpload></StandardDataUpload>
            <hr>
            <br><PhotoUpload></PhotoUpload>
            <hr>
            <br><PhotoMosaicUpload></PhotoMosaicUpload>
            <hr>
            <br><OnlineDateUpload></OnlineDateUpload>
            <hr>
            <br><ForecastUpload></ForecastUpload>
            <hr>
            <br><ValveConfigUpload></ValveConfigUpload>
          </b-tab>
          <b-tab no-body title="Locking">
            <br><LockingSettings></LockingSettings>
          </b-tab>
          <b-tab no-body title="Field">
            <br><FieldImport/>
          </b-tab>
        </b-tabs>
      </div>

    </div>

  </div>
</div>
</template>
<script>
import 'vue-awesome/icons/plus'
import Vue from 'vue'
import store from '../../store'

import WorkpackSettings from '../user/admin/WorkpackSettings.vue'
import LayerSettings from '../user/admin/LayerSettings.vue'
import LayerGroupSettings from '../user/admin/LayerGroupSettings.vue'
import LockingSettings from '../user/admin/LockingSettings.vue'
import ForecastUpload from '../user/admin/ForecastUpload.vue'
import OnlineDateUpload from '../user/admin/OnlineDateUpload.vue'
import ValveConfigUpload from '../user/admin/ValveConfigUpload.vue'
import StandardDataUpload from '../user/admin/StandardDataUpload.vue'
import PhotoUpload from '../user/admin/PhotoUpload.vue'
import PhotoMosaicUpload from '../user/admin/PhotoMosaicUpload.vue'
import GeneralConfig from '../user/admin/GeneralConfig.vue'
import FieldImport from './FieldImport'

export default {
  name: 'project-management',
  data() {
    return {
      tabIndex: 0
    }
  },
  components: {
    FieldImport,
    WorkpackSettings,
    LayerSettings,
    LayerGroupSettings,
    ForecastUpload,
    PhotoUpload,
    PhotoMosaicUpload,
    StandardDataUpload,
    GeneralConfig,
    LockingSettings,
    OnlineDateUpload,
    ValveConfigUpload
  },
  props: {
    workpack_id: {
      default: null
    }
  },
  computed: {
    menuRightCls: {
      get() {
        return this.$store.getters['user/menuRightCls']
      },
      set(val) {
        this.$store.commit('user/menuRightCls', val)
      }
    }
  },
  methods: {
    toggleRightMenu() {
      // this.showProjectList = false
      this.menuRightCls = this.menuRightCls !== '' ? '' : 'spmenu-open'
    },
    isToolEnabled(toolName) {
      let currentProject = this.$store.getters['project/currentProject']
      if (!currentProject || !currentProject.workpack) {
        return false
      }
      let enabled = true
      if (currentProject.workpack && currentProject.workpack['tool_map']) {
        enabled = currentProject.workpack['tool_map']['*'] || currentProject.workpack['tool_map'][toolName]
      }
      return enabled
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projectboard/ProjectManagement.vue